import React, { Component} from 'react';
 
// import API from'../utilities/API'
import {  Redirect  } from 'react-router-dom'
import Start from './Pages/start'
import Game from './Pages/game'
import End from './Pages/end'
class Voidcheddar3rddoz extends Component {
 
  constructor(props) {
    super(props);
   this.handleStateChange = this.handleStateChange.bind(this);
    this.state = {
      usr: props.data.usr,      
      logo: props.data.logo,
      gamestate: 'start',
      handleStateChange: this.handleStateChange,
    }
  }  
   handleStateChange(newstate){
    this.setState({gamestate: newstate});
   }
    render() { 
      let gamepage = {};  
      switch (this.state.gamestate){
        case 'start' :
          gamepage = <Start data={this.state} />;
          break;
        case 'game' :
          gamepage = <Game data={this.state}/>;
          break;
        case 'end' :
          gamepage = <End data={this.state}/>;
          break;
        default:
          gamepage = <Start data={this.state}/>;
      }
      
      
      // this.state.usr===false || this.state.usr.hasAdmin===false
      return (this.state.usr===false || this.state.usr.hasAdmin===false)?(<Redirect to ="../soon"/>):(<div className='mypage fluid-container p-3'>
              {gamepage} 
              </div>
              );            
              
  
      
    }  

  
}




export default Voidcheddar3rddoz; 


// WEBPACK FOOTER //
// ./src/components/Games/VoidCheddar/Voidcheddar3rddoz.js